import { observer } from 'mobx-react';
import useStore from '../../../../../store';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, ServerSideRowModelModule } from 'ag-grid-enterprise';
import { ServerGridConfig } from '../../../../../config/GridConfig';
import Message from '../../../../../config/Message';
import moment from 'moment';
import { displayFormats, FileStatusType } from '../../../../../config/Global';
import { Button } from 'antd';
const ListComponent = observer((props) => {
	ModuleRegistry.registerModules([ServerSideRowModelModule]);
	const { BULKACCOMMODATION } = useStore();
	const { openLogModal } = props;

	const ActionRenderer = (props) => {
		let isError = props.data.failRecordNumber;
		return (
			<div className="action-column">
				<Button
					type="text"
					title={isError ? 'See Error Log' : 'No Error found'}
					className="editIcon"
					onClick={() => {
						openLogModal(isError);
					}}
					disabled={!isError}
				>
					<svg
						className="svg-icon"
						style={{
							width: '1em',
							height: '1em',
							verticalAlign: 'middle',
						}}
						viewBox="0 0 1024 1024"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M758.6 469.1c35.6 0 69.9 6 101.8 17V72.5c0-39.1-31.7-70.7-70.7-70.7H95c-39.1 0-70.7 31.7-70.7 70.7v833.2c0 39.1 31.7 70.7 70.7 70.7h420.4c-43-53.5-68.8-121.4-68.8-195.4 0-172.2 139.7-311.9 312-311.9zM140.3 232.7c0-24.9 20.2-45 45-45h504.9c24.9 0 45 20.2 45 45 0 24.9-20.2 45-45 45H185.3c-24.8 0-45-20.1-45-45z m0 221.2c0-24.9 20.2-45 45-45h295.3c24.9 0 45 20.2 45 45 0 24.9-20.2 45-45 45H185.3c-24.8 0-45-20.1-45-45z m270.9 221.2c0 24.9-20.2 45-45 45H185.3c-24.9 0-45-20.2-45-45 0-24.9 20.2-45 45-45h180.9c24.8 0 45 20.2 45 45z"
							fill={!isError ? '#666' : 'red'}
						/>
						<path
							d="M758.6 539.9c-133.2 0-241.2 108-241.2 241.2s108 241.2 241.2 241.2 241.2-108 241.2-241.2-108-241.2-241.2-241.2z m148.2 262.2c0 15.1-12.2 27.3-27.3 27.3H750.6c-15.1 0-27.3-12.2-27.3-27.3V625.3c0-15.1 12.2-27.3 27.3-27.3 15.1 0 27.3 12.2 27.3 27.3v149.5h101.5c15.1 0 27.4 12.3 27.4 27.3z"
							fill={!isError ? '#666' : 'red'}
						/>
					</svg>
				</Button>
			</div>
		);
	};

	const colDefs = [
		// {
		// 	headerName: 'Sr. No',
		// 	valueGetter: 'node.rowIndex + 1',
		// 	minWidth: 80,
		// 	maxWidth: 100,
		// 	sortable: false,
		// },
		{
			headerName: 'Uploaded Date',
			field: 'updatedOn',
			sort: 'desc',
			minWidth: 140,
			cellRenderer: (params) =>
				moment(params.data.updatedOn).format(
					displayFormats.DATE_TIME_FORMAT
				),
		},
		{
			headerName: 'File Name',
			field: 'fileName',
			minWidth: 140,
		},
		{
			headerName: 'Fail Record Number',
			field: 'failRecordNumber',
			minWidth: 140,
			cellRenderer: (param) => param.data.failRecordNumber || 0,
		},
		{
			headerName: 'Status',
			field: 'isSuccess',
			minWidth: 140,
			cellRenderer: (param) => FileStatusType[param.data.isSuccess],
		},
		{
			headerName: 'Actions',
			field: 'actions',
			cellRenderer: 'ActionRenderer',
			pinned: 'right',
			sortable: false,
			filter: false,
			minWidth: 120,
			width: 120,
		},
	];

	return (
		<div
			className="ag-theme-quartz" // applying the grid theme
			style={{ height: 'calc(100vh - 140px)' }} // the grid will fill the size of the parent container>
		>
			<AgGridReact
				onGridReady={BULKACCOMMODATION.setupGrid}
				headerHeight={35}
				columnDefs={colDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={Message().noRecord}
				gridOptions={ServerGridConfig.options}
				rowSelection={'multiple'}
				components={{
					ActionRenderer,
				}}
			/>
		</div>
	);
});
export default ListComponent;
